<template>
  <!-- <button class="kt-aside-close " id="kt_aside_close_btn"><i class="la la-close"></i></button> -->
  <div id="kt_aside" class="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop">
    <!-- begin:: Aside Menu for Project list -->
    <div v-if="isOverview" id="kt_aside_menu_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
      <div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1">
        <ul class="kt-menu__nav ">
          <li
            class="kt-menu__item kt-menu__item--active"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'overview' })"
          >
            <router-link to="/" class="kt-menu__link ">
              <i class="kt-menu__link-icon flaticon2-architecture-and-city" /><span class="kt-menu__link-text">Projects</span>
            </router-link>
          </li>
          <li class="kt-menu__section ">
            <h4 class="kt-menu__section-text">
              OTHERS
            </h4>
            <i class="kt-menu__section-icon flaticon-more-v2" />
          </li>
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'demo' })"
          >
            <a href="https://demo.nlp.insightera.co.th/" class="kt-menu__link " target="_blank"><i class="kt-menu__link-icon flaticon2-browser-1" /><span class="kt-menu__link-text">API Demo</span></a>
          </li>
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'docs' })"
          >
            <a href="https://nlp.insightera.co.th/docs/v1.0/" class="kt-menu__link " target="_blank"><i class="kt-menu__link-icon flaticon2-document" /><span class="kt-menu__link-text">API Document</span></a>
          </li>
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'tokendebugger' })"
          >
            <router-link :to="`/tokendebugger`" class="kt-menu__link" target="_blank">
              <i class="kt-menu__link-icon flaticon2-settings" /><span class="kt-menu__link-text">Token Debugger</span>
            </router-link>
          </li>
          <!-- <li class="kt-menu__item " aria-haspopup="true">
            <a href="#" class="kt-menu__link "><i class="kt-menu__link-icon flaticon2-start-up" /><span class="kt-menu__link-text">Showcases</span></a>
          </li> -->
        </ul>
      </div>
    </div>
    <!-- end:: Aside Menu for Project list-->

    <!-- begin:: Aside Menu for Project Detail -->
    <div v-if="!isOverview && !isProfile && !isPassword" id="kt_aside_menu_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
      <div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1">
        <ul class="kt-menu__nav ">
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'overview' })"
          >
            <router-link to="/" class="kt-menu__link ">
              <i class="kt-menu__link-icon flaticon2-architecture-and-city" /><span class="kt-menu__link-text">Projects</span>
            </router-link>
          </li>
          <li class="kt-menu__section ">
            <h4 class="kt-menu__section-text">
              <!-- PROJECT -->
            </h4>
            <div class="kt-header__brand-nav">
              <div v-if="allProject.projects" class="dropdown">
                <button
                  type="button"
                  class="btn btn-hover-transparent-primary font-weight-bold dropdown-toggle dropdown-project-name"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <!-- {{ projectName ? projectName.name : 'PROJECT' }} -->
                  <span class="text-project-name kt-font-bolder mr-2">{{ projectName ? projectName.name : 'PROJECT' }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-project">
                  <ul class="kt-nav kt-nav--bold kt-nav--sm-space">
                    <li
                      v-for="project in allProject.projects"
                      :key="project.id"
                      class="kt-nav__item"
                      @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'dashboard' }); selectedProject()"
                    >
                      <router-link :to="`/dashboard/${project.id}`" class="kt-nav__link active">
                        <div>
                          <span class="kt-nav__link-text"> {{ project.name }} </span>
                          <div class="kt-widget1__sub kt-label-font-color-1">
                            {{ project.id.substr(0,10) }}
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <i class="kt-menu__section-icon flaticon-more-v2" />
          </li>
          <li
            class="kt-menu__item"
            :class="{ 'kt-menu__item kt-menu__item--active': isService }"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'service' })"
          >
            <router-link :to="`/service/${projectId}`" class="kt-menu__link ">
              <i class="kt-menu__link-icon flaticon2-browser-2" /><span class="kt-menu__link-text">API</span>
            </router-link>
          </li>
          <li
            class="kt-menu__item"
            :class="{ 'kt-menu__item kt-menu__item--active': isCredential }"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'credential' })"
          >
            <router-link :to="`/credential/${projectId}`" class="kt-menu__link ">
              <i class="kt-menu__link-icon flaticon2-lock" /><span class="kt-menu__link-text">Credential</span>
            </router-link>
          </li>
          <li
            class="kt-menu__item"
            :class="{ 'kt-menu__item kt-menu__item--active': isClassification }"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'classification' })"
          >
            <router-link :to="`/classification/${projectId}`" class="kt-menu__link ">
              <i class="kt-menu__link-icon flaticon2-layers-2" /><span class="kt-menu__link-text">Classification</span>
            </router-link>
          </li>
          <li
            class="kt-menu__item"
            :class="{ 'kt-menu__item kt-menu__item--active': isSettings }"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'settings' })"
          >
            <router-link :to="`/settings/${projectId}`" class="kt-menu__link ">
              <i class="kt-menu__link-icon flaticon2-gear" /><span class="kt-menu__link-text">Settings</span>
            </router-link>
          </li>
          <li class="kt-menu__section ">
            <h4 class="kt-menu__section-text">
              OTHERS
            </h4>
            <i class="kt-menu__section-icon flaticon-more-v2" />
          </li>
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'demo' })"
          >
            <a href="https://demo.nlp.insightera.co.th/" class="kt-menu__link " target="_blank"><i class="kt-menu__link-icon flaticon2-laptop" /><span class="kt-menu__link-text">API Demo</span></a>
          </li>
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'docs' })"
          >
            <a href="https://nlp.insightera.co.th/docs/v1.0/" class="kt-menu__link " target="_blank"><i class="kt-menu__link-icon flaticon2-file-1" /><span class="kt-menu__link-text">API Document</span></a>
          </li>
        </ul>
      </div>
    </div>
    <!-- end:: Aside Menu for Project Detail-->

    <!-- begin:: Aside Menu for Service Detail -->
    <!-- <div v-if="isService" id="kt_aside_menu_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
      <div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1">
        <ul class="kt-menu__nav ">
          <li class="kt-menu__item " aria-haspopup="true">
            <a href="/" class="kt-menu__link "><i class="kt-menu__link-icon flaticon2-architecture-and-city" /><span class="kt-menu__link-text">Projects</span></a>
          </li>
          <li class="kt-menu__section ">
            <h4 class="kt-menu__section-text">
              Others
            </h4>
            <i class="kt-menu__section-icon flaticon-more-v2" />
          </li>
          <li class="kt-menu__item" aria-haspopup="true">
            <a href="https://inse-nlp-demo.firebaseapp.com" class="kt-menu__link " target="_blank"><i class="kt-menu__link-icon flaticon2-browser-1" /><span class="kt-menu__link-text">API Demo</span></a>
          </li>
          <li class="kt-menu__item " aria-haspopup="true">
            <a href="https://nlp.insightera.co.th/docs/v1.0/" class="kt-menu__link " target="_blank"><i class="kt-menu__link-icon flaticon2-document" /><span class="kt-menu__link-text">API Document</span></a>
          </li>
        </ul>
      </div>
    </div> -->
    <!-- end:: Aside Menu for Service Detail-->

    <!-- <div v-if="isCredential || isClassification" id="kt_aside_menu_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
      <div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1">
        <ul class="kt-menu__nav ">
          <li class="kt-menu__item kt-menu__item--active" aria-haspopup="true">
            <a href="/" class="kt-menu__link "><i class="kt-menu__link-icon flaticon2-architecture-and-city" /><span class="kt-menu__link-text">Projects</span></a>
          </li>
        </ul>
      </div>
    </div> -->

    <!-- begin:: Aside Menu for User Profile Detail -->
    <div v-if="isProfile || isPassword" id="kt_aside_menu_user_profile_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
      <div id="kt_aside_menu_user_profile_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1">
        <ul class="kt-menu__nav">
          <li
            class="kt-menu__item"
            :class="{ 'kt-menu__item kt-menu__item--active': isProfile }"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'profile' })"
          >
            <router-link to="/profile" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-user-outline-symbol" />
              <span class="kt-menu__link-text">My Profile</span>
            </router-link>
          </li>
          <li
            v-if="!isLdapUser"
            class="kt-menu__item"
            :class="{ 'kt-menu__item kt-menu__item--active': isPassword }"
            aria-haspopup="true"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_sidebar', linkTo: 'password' })"
          >
            <router-link :to="`/profile/password`" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-lock" /><span class="kt-menu__link-text">Password</span>
            </router-link>
          </li>
          <li
            v-else
            class="ldap-password kt-menu__item"
            @mouseover="triggerTooltip"
            @mouseleave="disableTooltip"
          >
            <span class="ldap-password kt-menu__link">
              <i class="ldap-password kt-menu__link-icon flaticon2-lock" />
              <span class="ldap-password kt-menu__link-text">
                <span
                  class="ldap-password tooltip-box"
                  :data-toggle="`tooltip-copy`"
                  data-offset="90px 12px"
                  data-placement="bottom"
                  title="Not support changing password for LDAP users. Change password in LDAP server instead."
                />
                Password</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <!-- end:: Aside Menu for User Profile Detail-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return { }
  },
  computed: {
    ...mapGetters({
      allProject: 'project/getAllProject',
      getProjectDetail: 'project/getProjectDetailState',
      getWebServiceConnector: 'user/getWebServiceConnector',
      getIsLdapUser: 'user/getIsLdapUser'
    }),
    isDropdown () {
      return this.$route.name !== 'overview' && this.$route.name !== 'tokendebugger'
    },
    projectName () {
      return this.getProjectDetail[this.$route.params.projectId]
      // return this.allProject.projects.filter(project => project.id === this.$route.params.projectId)[0]
    },
    isOverview () {
      return this.$route.name && this.$route.name === 'overview'
    },
    isDashboard () {
      return this.$route.name && this.$route.name === 'dashboard'
    },
    isService () {
      return this.$route.name && this.$route.name === 'service'
    },
    isCredential () {
      return this.$route.name && this.$route.name === 'credential'
    },
    isProfile () {
      return this.$route.name && this.$route.name === 'profile'
    },
    isPassword () {
      return this.$route.name && this.$route.name === 'password'
    },
    isClassification () {
      return this.$route.name && this.$route.name === 'classification'
    },
    isSettings () {
      return this.$route.name && this.$route.name === 'settings'
    },
    projectId () {
      return this.$route.params.projectId
    },
    isLdapUser () {
      return this.getIsLdapUser
    }
  },
  watch: {

  },
  mounted () {
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    selectedProject () { // log
      const sessionId = this.getSessionId
      const userId = this.getUserId
      const webServiceConnector = this.getWebServiceConnector
      webServiceConnector.loggerFluentd({
        '"userId"': userId,
        '"sessionId"': sessionId,
        '"inpage"': '/overview',
        '"action"': 'click',
        '"element"': 'selected-dropdown-project'
      })
    },
    disableTooltip () {
      // eslint-disable-next-line no-undef
      $('[data-toggle=tooltip-copy]').tooltip('hide')
    },
    triggerTooltip () {
      // eslint-disable-next-line no-undef
      $('[data-toggle=tooltip-copy]').tooltip('show')
    }
  }
}
</script>
<style scoped>
  .text-project-name {
    color: #6F4FFF;
  }
  .dropdown-project-name {
    padding: initial !important;
  }
  .btn.dropdown-toggle {
    color: #6F4FFF;
  }
  .tooltip-box {
    position: relative;
    left: 3px;
  }
  .ldap-password {
    cursor: default !important;
    text-decoration: lightgrey !important;
    background-color: unset !important;
    color: silver !important;
    opacity: 0.85 !important;
  }
</style>
